import { Component } from '@angular/core';
import { ImpersonateComponent } from "./impersonate/impersonate.component";
import { CommonModule } from '@angular/common';
import { TabsModule } from 'primeng/tabs';

@Component({
  selector: 'app-support',
  imports: [CommonModule, TabsModule, ImpersonateComponent],
  templateUrl: './support.component.html',
  styleUrl: './support.component.scss'
})
export class SupportComponent {

}
